import moment from 'moment-timezone'
import * as AT from '../actions/_types'

export default function callLog(
  prevState = {
    date: moment(),
    timeZone: moment().format('Z'),
    callDataByDate: {},
    patientCallData: [],
    filter: 'all',
    isFetching: false,
    popoverPage: '',
    currentSelectedTab: 'callLog',
    newContactInfo: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      attribution: '',
      otherAttribution: '',
      id: null,
    },
    matchingContacts: [],
    contacts: [],
    conversionStats: {
      totalLeads: 0,
      totalLeadsLast30: 0,
      totalLeadsPrev30: 0,
      totalConversions: 0,
      meanConversionTime: 0,
    },
    contactsFetched: false,
  },
  action,
) {
  switch (action.type) {
    case AT.COREDIAL_START_FETCHING: {
      return {
        ...prevState,
        isFetching: true,
      }
    }
    case AT.COREDIAL_SET_CALL_DATA: {
      const { date, calls } = action
      const newCallData = {
        ...prevState.callDataByDate,
        [date]: calls,
      }
      return {
        ...prevState,
        callDataByDate: newCallData,
        isFetching: false,
      }
    }
    case AT.COREDIAL_CLEAR_CALL_DATA: {
      return {
        ...prevState,
        callDataByDate: {},
      }
    }
    case AT.COREDIAL_SET_DATE: {
      const { date } = action

      return {
        ...prevState,
        date,
      }
    }
    case AT.COREDIAL_SET_PATIENT_CALL_DATA: {
      const { patientCallData } = action

      return {
        ...prevState,
        patientCallData,
        isFetching: false,
      }
    }
    case AT.COREDIAL_SET_CALL_LOG_FILTER: {
      const { callLogFilter } = action
      return {
        ...prevState,
        filter: callLogFilter,
      }
    }
    case AT.COREDIAL_SET_POPOVER: {
      const { pageName } = action
      return {
        ...prevState,
        popoverPage: pageName,
      }
    }
    case AT.COREDIAL_SET_TAB: {
      const { heading } = action
      return {
        ...prevState,
        currentSelectedTab: heading,
      }
    }
    case AT.COREDIAL_SET_NEW_CONTACT_INFO: {
      const { contactInfoType, value } = action
      const newContactInfo = { ...prevState.newContactInfo }
      switch (contactInfoType) {
        case 'firstName': {
          newContactInfo.firstName = value
          break
        }
        case 'lastName': {
          newContactInfo.lastName = value
          break
        }
        case 'email': {
          newContactInfo.email = value
          break
        }
        case 'phoneNumber': {
          newContactInfo.phoneNumber = value
          break
        }
        case 'attribution': {
          newContactInfo.attribution = value
          break
        }
        case 'otherAttribution': {
          newContactInfo.otherAttribution = value
          break
        }
        case 'id': {
          newContactInfo.id = value
          break
        }
        default: {
          break
        }
      }
      return {
        ...prevState,
        newContactInfo,
      }
    }
    case AT.COREDIAL_SET_MATCHING_CONTACTS: {
      const { matchingContacts } = action
      return {
        ...prevState,
        matchingContacts,
      }
    }
    case AT.COREDIAL_START_FETCHING_CONTACTS: {
      return {
        ...prevState,
        contactsFetched: false,
      }
    }
    case AT.COREDIAL_SET_CONTACTS: {
      const { contacts, conversionStats } = action
      const {
        total_leads: totalLeads,
        total_leads_last_30: totalLeadsLast30,
        total_leads_prev_30: totalLeadsPrev30,
        total_conversions: totalConversions,
        mean_conversion_time: meanConversionTime,
      } = conversionStats
      return {
        ...prevState,
        contacts,
        conversionStats: {
          totalLeads,
          totalLeadsLast30,
          totalLeadsPrev30,
          totalConversions,
          meanConversionTime,
        },
        contactsFetched: true,
      }
    }
    default: {
      return prevState
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/call-log.js